// src/components/game/GamesPage.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GamesPage = ({ isDarkMode }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');

  const games = [
    // 🎮 არსებული თამაშები
    { id: 'puzzle', name: 'პაზლი', icon: '🧩', desc: 'ააწყვეთ სურათი 4x4 ბადეზე', color: '#667eea', category: 'logic' },
    { id: 'memory', name: 'მეხსიერება', icon: '🎯', desc: 'იპოვეთ IT სიმბოლოების წყვილები', color: '#f093fb', category: 'memory' },
    { id: 'code-quiz', name: 'ქვიზი', icon: '💻', desc: 'პროგრამირების ტესტი', color: '#4facfe', category: 'quiz' },
    { id: 'typing', name: 'სწრაფი კრება', icon: '⌨️', desc: 'კოდის აკრეფის სიჩქარის ტესტი', color: '#43e97b', category: 'typing' },
    { id: 'binary', name: 'ბინარული', icon: '🔢', desc: 'ორობითი ↔ ათობითი გადაყვანა', color: '#fa709a', category: 'math' },
    { id: 'logic', name: 'ლოგიკა', icon: '🧠', desc: 'ლოგიკური გამოცანები', color: '#a18cd1', category: 'logic' },
    { id: 'dragdrop', name: 'განლაგება', icon: '🧩', desc: 'კომპონენტების აწყობა Drag & Drop-ით', color: '#fbc2eb', category: 'logic' },
    { id: 'bug', name: 'შეცდომები', icon: '🐛', desc: 'იპოვეთ JavaScript-ის შეცდომები', color: '#ffecd2', category: 'quiz' },
    { id: 'keyboard', name: 'კლავიშები', icon: '⌨️', desc: 'კლავიატურის მალსახმობები', color: '#a8edea', category: 'typing' },
    { id: 'code-runner', name: 'კოდი', icon: '⚡', desc: 'დაწერეთ და გაუშვით JavaScript', color: '#ff9a9e', category: 'code' },
    // 🆕 ახალი თამაშები
    { id: 'jigsaw', name: 'Jigsaw', icon: '🧩', desc: 'რთული პაზლი მრავალი სურათით', color: '#8b5cf6', category: 'logic', new: true },
    { id: 'sorting', name: 'სორტირება', icon: '📊', desc: 'დაალაგეთ რიცხვები სწორად', color: '#06b6d4', category: 'math', new: true },
    { id: 'math-quiz', name: 'მათემატიკა', icon: '📐', desc: 'მათემატიკური ამოცანები', color: '#f59e0b', category: 'math', new: true },
  ];

  const categories = [
    { id: 'all', name: '📚 ყველა', color: '#667eea' },
    { id: 'logic', name: '🧩 ლოგიკური', color: '#a18cd1' },
    { id: 'memory', name: '🎯 მეხსიერება', color: '#f093fb' },
    { id: 'quiz', name: '💻 ქვიზი', color: '#4facfe' },
    { id: 'typing', name: '⌨️ კრება', color: '#43e97b' },
    { id: 'math', name: '📐 მათემატიკა', color: '#f59e0b' },
    { id: 'code', name: '⚡ კოდი', color: '#ff9a9e' },
  ];

  const filteredGames = games.filter(game => {
    const matchesSearch = game.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                          game.desc.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = selectedCategory === 'all' || game.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const getCategoryEmoji = (category) => {
    const found = categories.find(c => c.id === category);
    return found ? found.name.split(' ')[0] : '🎮';
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: isDarkMode 
        ? 'linear-gradient(135deg, #0a0a1a 0%, #1a1a2e 100%)' 
        : 'linear-gradient(135deg, #f5f5f5 0%, #e8e8e8 100%)',
      padding: 'clamp(12px, 3vw, 20px)'
    }}>
      <style>
        {`
          @keyframes slideUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          .game-card {
            animation: slideUp 0.6s ease-out;
          }
          .game-card:hover {
            transform: translateY(-8px) scale(1.02);
          }
          @media (max-width: 480px) {
            .game-card:hover {
              transform: translateY(-4px) scale(1.01);
            }
          }
        `}
      </style>

      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* უკან დაბრუნება */}
        <Link to="/" style={{
          display: 'inline-block',
          padding: 'clamp(10px, 2vw, 12px) clamp(20px, 4vw, 28px)',
          margin: 'clamp(10px, 2vw, 20px) 0',
          background: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)',
          color: isDarkMode ? '#fff' : '#000',
          textDecoration: 'none',
          borderRadius: '12px',
          transition: 'all 0.3s',
          backdropFilter: 'blur(10px)',
          border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
          fontWeight: '500',
          fontSize: 'clamp(13px, 1.5vw, 16px)'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateX(-5px)';
          e.target.style.background = isDarkMode ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateX(0)';
          e.target.style.background = isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)';
        }}>
          ← მთავარ გვერდზე
        </Link>

        {/* სათაური */}
        <h1 style={{
          textAlign: 'center',
          fontSize: 'clamp(1.8rem, 5vw, 3.5rem)',
          color: isDarkMode ? '#fff' : '#000',
          marginBottom: 'clamp(8px, 2vw, 10px)',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>
          🎮 IT თამაშები
        </h1>
        <p style={{
          textAlign: 'center',
          color: isDarkMode ? '#aaa' : '#666',
          marginBottom: 'clamp(20px, 3vw, 30px)',
          fontSize: 'clamp(0.9rem, 1.5vw, 1.2rem)'
        }}>
          {filteredGames.length} თამაში ტვინის სავარჯიშოდ IT სპეციალისტებისთვის
        </p>

        {/* Search & Filter */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'clamp(10px, 1.5vw, 15px)',
          marginBottom: 'clamp(20px, 3vw, 30px)',
          padding: 'clamp(15px, 2vw, 20px)',
          background: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
          borderRadius: '16px',
          border: isDarkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)'
        }}>
          {/* Search */}
          <div style={{ position: 'relative' }}>
            <span style={{
              position: 'absolute',
              left: 'clamp(12px, 1.5vw, 14px)',
              top: '50%',
              transform: 'translateY(-50%)',
              fontSize: 'clamp(16px, 1.5vw, 18px)'
            }}>🔍</span>
            <input
              type="text"
              placeholder="მოძებნე თამაში..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{
                width: '100%',
                padding: 'clamp(12px, 1.5vw, 14px) clamp(12px, 1.5vw, 14px) clamp(12px, 1.5vw, 14px) clamp(40px, 5vw, 48px)',
                borderRadius: '12px',
                border: '2px solid',
                borderColor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
                background: isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(255,255,255,0.8)',
                color: isDarkMode ? '#fff' : '#000',
                fontSize: 'clamp(14px, 1.5vw, 16px)',
                outline: 'none',
                transition: 'all 0.3s',
                backdropFilter: 'blur(10px)',
                WebkitAppearance: 'none'
              }}
              onFocus={(e) => {
                e.target.style.borderColor = '#667eea';
                e.target.style.boxShadow = '0 0 30px rgba(102,126,234,0.1)';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
                e.target.style.boxShadow = 'none';
              }}
            />
          </div>

          {/* Categories - Mobile Friendly */}
          <div style={{
            display: 'flex',
            gap: 'clamp(6px, 1vw, 8px)',
            flexWrap: 'wrap',
            justifyContent: 'center'
          }}>
            {categories.map(cat => (
              <button
                key={cat.id}
                onClick={() => setSelectedCategory(cat.id)}
                style={{
                  padding: 'clamp(6px, 1vw, 8px) clamp(12px, 1.5vw, 16px)',
                  borderRadius: '20px',
                  border: '2px solid',
                  borderColor: selectedCategory === cat.id ? cat.color : (isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'),
                  background: selectedCategory === cat.id ? cat.color : 'transparent',
                  color: selectedCategory === cat.id ? '#fff' : (isDarkMode ? '#aaa' : '#666'),
                  fontSize: 'clamp(11px, 1.2vw, 13px)',
                  cursor: 'pointer',
                  transition: 'all 0.3s',
                  fontWeight: selectedCategory === cat.id ? 'bold' : 'normal',
                  boxShadow: selectedCategory === cat.id ? `0 4px 15px ${cat.color}40` : 'none',
                  touchAction: 'manipulation',
                  WebkitTapHighlightColor: 'transparent'
                }}
                onMouseEnter={(e) => {
                  if (selectedCategory !== cat.id) {
                    e.target.style.transform = 'scale(1.05)';
                    e.target.style.borderColor = cat.color;
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedCategory !== cat.id) {
                    e.target.style.transform = 'scale(1)';
                    e.target.style.borderColor = isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
                  }
                }}
              >
                {cat.name}
              </button>
            ))}
          </div>
        </div>

        {/* Games Grid - Mobile Responsive */}
        {filteredGames.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: 'clamp(40px, 8vw, 60px) 20px',
            color: isDarkMode ? '#666' : '#999'
          }}>
            <div style={{ fontSize: 'clamp(48px, 8vw, 64px)', marginBottom: '20px' }}>🔍</div>
            <h3 style={{ color: isDarkMode ? '#fff' : '#000', fontSize: 'clamp(18px, 2vw, 24px)' }}>
              თამაში ვერ მოიძებნა
            </h3>
            <p style={{ fontSize: 'clamp(14px, 1.5vw, 16px)' }}>
              სცადეთ სხვა საძიებო სიტყვა ან კატეგორია
            </p>
          </div>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
            gap: 'clamp(15px, 2vw, 25px)'
          }}>
            {filteredGames.map((game, index) => (
              <Link
                key={game.id}
                to={`/${game.id}`}
                className="game-card"
                style={{
                  background: isDarkMode 
                    ? 'rgba(26, 26, 46, 0.9)' 
                    : 'rgba(255, 255, 255, 0.9)',
                  borderRadius: 'clamp(12px, 1.5vw, 16px)',
                  padding: 'clamp(16px, 2vw, 25px)',
                  textAlign: 'center',
                  boxShadow: isDarkMode 
                    ? '0 4px 20px rgba(0,0,0,0.3)' 
                    : '0 4px 20px rgba(0,0,0,0.06)',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  textDecoration: 'none',
                  display: 'block',
                  border: isDarkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)',
                  position: 'relative',
                  backdropFilter: 'blur(10px)',
                  animationDelay: `${index * 50}ms`
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px) scale(1.02)';
                  e.currentTarget.style.boxShadow = isDarkMode 
                    ? '0 8px 40px rgba(0,0,0,0.5)' 
                    : '0 8px 40px rgba(0,0,0,0.12)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = isDarkMode 
                    ? '0 4px 20px rgba(0,0,0,0.3)' 
                    : '0 4px 20px rgba(0,0,0,0.06)';
                }}
              >
                {/* Category Badge */}
                <span style={{
                  position: 'absolute',
                  top: 'clamp(8px, 1vw, 12px)',
                  left: 'clamp(8px, 1vw, 12px)',
                  fontSize: 'clamp(10px, 1vw, 11px)',
                  color: isDarkMode ? '#666' : '#999',
                  background: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)',
                  padding: '2px 10px',
                  borderRadius: '20px'
                }}>
                  {getCategoryEmoji(game.category)}
                </span>

                {/* NEW Badge */}
                {game.new && (
                  <span style={{
                    position: 'absolute',
                    top: '-6px',
                    right: '-6px',
                    background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                    color: '#fff',
                    padding: 'clamp(3px, 0.5vw, 4px) clamp(10px, 1.5vw, 14px)',
                    borderRadius: '20px',
                    fontSize: 'clamp(9px, 1vw, 11px)',
                    fontWeight: 'bold',
                    boxShadow: '0 2px 15px rgba(239,68,68,0.4)',
                    animation: 'pulse 2s infinite'
                  }}>
                    NEW
                  </span>
                )}

                <div style={{ 
                  fontSize: 'clamp(36px, 8vw, 56px)', 
                  marginBottom: 'clamp(8px, 1vw, 12px)',
                  filter: 'drop-shadow(0 4px 10px rgba(0,0,0,0.1))'
                }}>
                  {game.icon}
                </div>
                <h3 style={{ 
                  color: isDarkMode ? '#fff' : '#000', 
                  marginBottom: 'clamp(6px, 0.8vw, 8px)',
                  fontSize: 'clamp(14px, 1.5vw, 20px)',
                  fontWeight: 'bold'
                }}>
                  {game.name}
                </h3>
                <p style={{ 
                  color: isDarkMode ? '#aaa' : '#666', 
                  fontSize: 'clamp(11px, 1.2vw, 14px)',
                  marginBottom: 'clamp(12px, 1.5vw, 15px)',
                  minHeight: 'clamp(32px, 4vw, 42px)',
                  lineHeight: '1.4'
                }}>
                  {game.desc}
                </p>
                <div style={{
                  padding: 'clamp(10px, 1vw, 12px)',
                  background: game.color,
                  borderRadius: 'clamp(10px, 1vw, 12px)',
                  color: '#fff',
                  fontSize: 'clamp(12px, 1.2vw, 14px)',
                  fontWeight: 'bold',
                  transition: 'all 0.3s',
                  boxShadow: `0 4px 20px ${game.color}40`
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = '0.85';
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = '1';
                  e.target.style.transform = 'scale(1)';
                }}>
                  🚀 ითამაშე
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* Stats - Mobile Responsive */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
          gap: 'clamp(15px, 2vw, 20px)',
          marginTop: 'clamp(30px, 4vw, 40px)',
          padding: 'clamp(20px, 2vw, 25px)',
          background: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
          borderRadius: '16px',
          border: isDarkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)',
          backdropFilter: 'blur(10px)'
        }}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(28px, 4vw, 32px)', color: '#667eea' }}>🎮</div>
            <div style={{ fontSize: 'clamp(18px, 2.5vw, 22px)', fontWeight: 'bold', color: isDarkMode ? '#fff' : '#000' }}>
              {games.length}
            </div>
            <div style={{ fontSize: 'clamp(11px, 1.2vw, 13px)', color: isDarkMode ? '#666' : '#999' }}>თამაში</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(28px, 4vw, 32px)', color: '#4ade80' }}>🧠</div>
            <div style={{ fontSize: 'clamp(18px, 2.5vw, 22px)', fontWeight: 'bold', color: isDarkMode ? '#fff' : '#000' }}>IT</div>
            <div style={{ fontSize: 'clamp(11px, 1.2vw, 13px)', color: isDarkMode ? '#666' : '#999' }}>სპეციალობა</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(28px, 4vw, 32px)', color: '#f59e0b' }}>⭐</div>
            <div style={{ fontSize: 'clamp(18px, 2.5vw, 22px)', fontWeight: 'bold', color: isDarkMode ? '#fff' : '#000' }}>
              {games.filter(g => g.new).length}
            </div>
            <div style={{ fontSize: 'clamp(11px, 1.2vw, 13px)', color: isDarkMode ? '#666' : '#999' }}>ახალი თამაში</div>
          </div>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 'clamp(28px, 4vw, 32px)', color: '#8b5cf6' }}>📊</div>
            <div style={{ fontSize: 'clamp(18px, 2.5vw, 22px)', fontWeight: 'bold', color: isDarkMode ? '#fff' : '#000' }}>
              {[...new Set(games.map(g => g.category))].length}
            </div>
            <div style={{ fontSize: 'clamp(11px, 1.2vw, 13px)', color: isDarkMode ? '#666' : '#999' }}>კატეგორია</div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          textAlign: 'center',
          marginTop: 'clamp(30px, 5vw, 50px)',
          padding: 'clamp(15px, 2vw, 20px)',
          color: isDarkMode ? '#555' : '#ccc',
          fontSize: 'clamp(12px, 1.2vw, 14px)',
          borderTop: isDarkMode ? '1px solid rgba(255,255,255,0.05)' : '1px solid rgba(0,0,0,0.05)'
        }}>
          💡 {games.length} თამაში IT სპეციალისტებისთვის
          <br />
          <span style={{ fontSize: 'clamp(10px, 1vw, 12px)', opacity: 0.6 }}>
            🚀 ითამაშე, ისწავლე, განვითარდი!
          </span>
        </div>
      </div>
    </div>
  );
};

export default GamesPage;